var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "simple-table-builder",
            centered: "",
            size: "xl",
            "modal-class": _vm.isFullscreen
              ? "modal-1200 table-builder-fullscreen"
              : "modal-1200",
          },
          on: { ok: _vm.onSave },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function ({ close }) {
                return [
                  _c("h5", { staticClass: "modal-title table-builder-title" }, [
                    _vm._v("\n        Table Builder\n      "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center ml-auto" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "builder-btn builder-btn--ghost builder-btn--icon",
                          attrs: {
                            type: "button",
                            title: _vm.isFullscreen
                              ? "Exit full screen"
                              : "Full screen",
                          },
                          on: {
                            click: function ($event) {
                              _vm.isFullscreen = !_vm.isFullscreen
                            },
                          },
                        },
                        [
                          _c("LucideIcon", {
                            attrs: {
                              name: _vm.isFullscreen
                                ? "minimize-2"
                                : "maximize-2",
                              size: 16,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "builder-divider mx-2" }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "builder-btn builder-btn--ghost builder-btn--icon",
                          attrs: { type: "button", "aria-label": "Close" },
                          on: {
                            click: function ($event) {
                              return close()
                            },
                          },
                        },
                        [_c("LucideIcon", { attrs: { name: "x", size: 16 } })],
                        1
                      ),
                    ]
                  ),
                ]
              },
            },
            {
              key: "modal-footer",
              fn: function ({ ok, cancel }) {
                return [
                  _c("div", { staticClass: "d-flex" }, [
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn builder-btn--lg mr-2",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return cancel()
                          },
                        },
                      },
                      [_vm._v("\n          Close\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "builder-btn builder-btn--lg builder-btn--primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return ok()
                          },
                        },
                      },
                      [_vm._v("\n          Save table\n        ")]
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm.table && _vm.table.rows.length
            ? _c("div", { staticClass: "mb-2" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "table-toolbar table-toolbar--main d-flex flex-wrap align-items-center",
                  },
                  [
                    _c(
                      "b-dropdown",
                      {
                        attrs: {
                          variant: "link",
                          "no-caret": "",
                          "toggle-class": "builder-btn",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n            Static Cells\n            "
                                  ),
                                  _c("LucideIcon", {
                                    attrs: { name: "chevron-down", size: 14 },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1093618883
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          { on: { click: _vm.addStaticRowAbove } },
                          [
                            _vm._v(
                              "\n            Add Static Row above the table\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          { on: { click: _vm.addStaticRowBelow } },
                          [
                            _vm._v(
                              "\n            Add Static Row below the table\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              disabled: !_vm.canAddStaticRowAtSelection,
                              title:
                                "Select a cell of the row you want it above",
                            },
                            on: { click: _vm.addStaticRowAboveSelected },
                          },
                          [
                            _vm._v(
                              "\n            Add Static Row above the selected row\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              disabled: !_vm.canAddStaticRowAtSelection,
                              title:
                                "Select a cell of the row you want it below",
                            },
                            on: { click: _vm.addStaticRowBelowSelected },
                          },
                          [
                            _vm._v(
                              "\n            Add Static Row below the selected row\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              disabled: !_vm.canAddStaticCol,
                              title:
                                "Select a static cell that covers more than one column",
                            },
                            on: { click: _vm.addStaticCol },
                          },
                          [_vm._v("\n            Add Static Col\n          ")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "builder-divider" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn builder-btn--ghost",
                        attrs: { type: "button", title: "Add Row" },
                        on: { click: _vm.addRow },
                      },
                      [
                        _c("LucideIcon", { attrs: { name: "plus", size: 16 } }),
                        _vm._v("\n          Row\n        "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn builder-btn--ghost",
                        attrs: { type: "button", title: "Add Column" },
                        on: { click: _vm.addColumn },
                      },
                      [
                        _c("LucideIcon", { attrs: { name: "plus", size: 16 } }),
                        _vm._v("\n          Column\n        "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn builder-btn--ghost",
                        attrs: {
                          type: "button",
                          title: "Remove Row",
                          disabled: !_vm.canRemoveRow,
                        },
                        on: { click: _vm.removeRow },
                      },
                      [
                        _c("LucideIcon", {
                          attrs: { name: "minus", size: 16 },
                        }),
                        _vm._v("\n          Row\n        "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn builder-btn--ghost",
                        attrs: {
                          type: "button",
                          title: "Remove Column",
                          disabled: !_vm.canRemoveColumn,
                        },
                        on: { click: _vm.removeColumn },
                      },
                      [
                        _c("LucideIcon", {
                          attrs: { name: "minus", size: 16 },
                        }),
                        _vm._v("\n          Column\n        "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "builder-divider" }),
                    _vm._v(" "),
                    _c(
                      "DropdownCounter",
                      {
                        attrs: {
                          value: _vm.getStyleValue("font-size", 0),
                          min: 1,
                          step: 1,
                          variant: "link",
                          "no-caret": "",
                          "toggle-class":
                            "builder-btn builder-btn--ghost builder-btn--icon",
                        },
                        on: {
                          input: (value) =>
                            _vm.onChangeStyleOfTable("font-size", value, "px"),
                        },
                      },
                      [_c("LucideIcon", { attrs: { name: "type", size: 16 } })],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "DropdownCounter",
                      {
                        attrs: {
                          value: _vm.getStyleValue("border-width", 0),
                          min: 0,
                          step: 1,
                          variant: "link",
                          "no-caret": "",
                          "toggle-class":
                            "builder-btn builder-btn--ghost builder-btn--icon",
                        },
                        on: {
                          input: (value) =>
                            _vm.onChangeStyleOfTable(
                              "border-width",
                              value,
                              "px",
                              true
                            ),
                        },
                      },
                      [
                        _c("LucideIcon", {
                          attrs: { name: "square", size: 16 },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "table-toolbar__swatch" },
                      [
                        _c("ColorPicker", {
                          attrs: {
                            value: _vm.getStyleValue("color", "#000000"),
                          },
                          on: {
                            input: (value) =>
                              _vm.onChangeStyleOfTable("color", value),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center ml-auto" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "builder-label mb-0 mr-2",
                            attrs: { for: "table-width" },
                          },
                          [_vm._v("\n            W\n          ")]
                        ),
                        _vm._v(" "),
                        _c("b-input", {
                          staticClass: "table-toolbar__size-input",
                          attrs: {
                            id: "table-width",
                            value: _vm.tableWidth,
                            type: "number",
                          },
                          on: { input: (value) => _vm.changeTableWidth(value) },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "builder-label mb-0 ml-3 mr-2",
                            attrs: { for: "table-height" },
                          },
                          [_vm._v("\n            H\n          ")]
                        ),
                        _vm._v(" "),
                        _c("b-input", {
                          staticClass: "table-toolbar__size-input",
                          attrs: {
                            id: "table-height",
                            value: _vm.tableHeight,
                            type: "number",
                            disabled: _vm.autoHeight,
                          },
                          on: {
                            input: (value) => _vm.changeTableHeight(value),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "table-toolbar__switch ml-3",
                            attrs: {
                              switch: "",
                              title:
                                "A cell's Fixed Width counts its paddings and borders, so a column set to 250 takes 250 on the page",
                            },
                            on: { change: _vm.onChangeBorderBoxWidths },
                            model: {
                              value: _vm.borderBoxWidths,
                              callback: function ($$v) {
                                _vm.borderBoxWidths = $$v
                              },
                              expression: "borderBoxWidths",
                            },
                          },
                          [
                            _vm._v(
                              "\n            Width includes paddings\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "table-toolbar d-flex flex-wrap align-items-center mb-3",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn",
                        attrs: {
                          type: "button",
                          title: "Insert Row Above",
                          disabled: !_vm.canInsertRowAbove,
                        },
                        on: { click: _vm.insertRowAbove },
                      },
                      [
                        _c("LucideIcon", { attrs: { name: "plus", size: 14 } }),
                        _vm._v("\n          Row Above\n        "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn",
                        attrs: {
                          type: "button",
                          title: "Insert Row Below",
                          disabled: !_vm.canInsertRowBelow,
                        },
                        on: { click: _vm.insertRowBelow },
                      },
                      [
                        _c("LucideIcon", { attrs: { name: "plus", size: 14 } }),
                        _vm._v("\n          Row Below\n        "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn",
                        attrs: {
                          type: "button",
                          title: "Insert Column Left",
                          disabled: !_vm.canInsertColumnLeft,
                        },
                        on: { click: _vm.insertColumnLeft },
                      },
                      [
                        _c("LucideIcon", { attrs: { name: "plus", size: 14 } }),
                        _vm._v("\n          Column Left\n        "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn",
                        attrs: {
                          type: "button",
                          title: "Insert Column Right",
                          disabled: !_vm.canInsertColumnRight,
                        },
                        on: { click: _vm.insertColumnRight },
                      },
                      [
                        _c("LucideIcon", { attrs: { name: "plus", size: 14 } }),
                        _vm._v("\n          Column Right\n        "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "builder-divider" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn",
                        attrs: {
                          type: "button",
                          title: "Move Row Up",
                          disabled: !_vm.canMoveRowUp,
                        },
                        on: { click: _vm.moveRowUp },
                      },
                      [_vm._v("\n          Move ↑\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn",
                        attrs: {
                          type: "button",
                          title: "Move Row Down",
                          disabled: !_vm.canMoveRowDown,
                        },
                        on: { click: _vm.moveRowDown },
                      },
                      [_vm._v("\n          Move ↓\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn",
                        attrs: {
                          type: "button",
                          title: "Move Column Left",
                          disabled: !_vm.canMoveColumnLeft,
                        },
                        on: { click: _vm.moveColumnLeft },
                      },
                      [_vm._v("\n          Move ←\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "builder-btn",
                        attrs: {
                          type: "button",
                          title: "Move Column Right",
                          disabled: !_vm.canMoveColumnRight,
                        },
                        on: { click: _vm.moveColumnRight },
                      },
                      [_vm._v("\n          Move →\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-inline-flex align-items-center justify-content-center table-zoom-control ml-auto",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "table-zoom-control__btn",
                            attrs: {
                              type: "button",
                              title: "Zoom out",
                              "aria-label": "Zoom out",
                              disabled: _vm.zoomLevel <= 25,
                            },
                            on: { click: _vm.zoomOut },
                          },
                          [
                            _c("LucideIcon", {
                              attrs: { name: "zoom-out", size: 14 },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "table-zoom-control__value" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.zoomLevel) +
                                "%\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "table-zoom-control__btn",
                            attrs: {
                              type: "button",
                              title: "Zoom in",
                              "aria-label": "Zoom in",
                              disabled: _vm.zoomLevel >= 100,
                            },
                            on: { click: _vm.zoomIn },
                          },
                          [
                            _c("LucideIcon", {
                              attrs: { name: "zoom-in", size: 14 },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-dropdown",
                      {
                        attrs: {
                          variant: "link",
                          "no-caret": "",
                          right: "",
                          "toggle-class": "builder-btn",
                          "menu-class": "table-options-menu",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n            Table Options\n            "
                                  ),
                                  _c("LucideIcon", {
                                    attrs: { name: "chevron-down", size: 14 },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          815477696
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "b-dropdown-form",
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                staticClass: "mb-2",
                                on: { change: _vm.handleAutoHeightChange },
                                model: {
                                  value: _vm.autoHeight,
                                  callback: function ($$v) {
                                    _vm.autoHeight = $$v
                                  },
                                  expression: "autoHeight",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Auto-height\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                staticClass: "mb-2",
                                on: { change: _vm.handleAdjustFontSizeToTable },
                                model: {
                                  value: _vm.autoFontSize,
                                  callback: function ($$v) {
                                    _vm.autoFontSize = $$v
                                  },
                                  expression: "autoFontSize",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Adjust font to table size\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                staticClass: "mb-2",
                                on: { change: _vm.onChangeTableColumnMode },
                                model: {
                                  value: _vm.tableColumnMode,
                                  callback: function ($$v) {
                                    _vm.tableColumnMode = $$v
                                  },
                                  expression: "tableColumnMode",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Column Mode\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                staticClass: "mb-2",
                                on: { change: _vm.onChangeHideHeaders },
                                model: {
                                  value: _vm.hideHeadersToggle,
                                  callback: function ($$v) {
                                    _vm.hideHeadersToggle = $$v
                                  },
                                  expression: "hideHeadersToggle",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Hide headers\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                staticClass: "mb-2",
                                model: {
                                  value: _vm.mergeSameValues,
                                  callback: function ($$v) {
                                    _vm.mergeSameValues = $$v
                                  },
                                  expression: "mergeSameValues",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Merge cells with same values\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  title:
                                    "Show ellipsis when text exceeds the cell width",
                                },
                                model: {
                                  value: _vm.truncateLongText,
                                  callback: function ($$v) {
                                    _vm.truncateLongText = $$v
                                  },
                                  expression: "truncateLongText",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Truncate long text\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.selectedCells.length
                  ? _c("div", { staticClass: "table-cell-panel d-flex" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "table-cell-panel__side d-flex flex-column",
                        },
                        [
                          _vm.themeStyles
                            ? _c("Multiselect", {
                                staticClass: "table-multiselect",
                                attrs: {
                                  placeholder: "Select style",
                                  "track-by": "name",
                                  label: "name",
                                  "select-label": " ",
                                  "deselect-label": " ",
                                  options: _vm.themeStyles,
                                  "allow-empty": false,
                                },
                                on: { input: _vm.applyTextStyle },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              style: _vm.getStylePreview(
                                                props.option
                                              ),
                                            },
                                            [_vm._v(_vm._s(props.option.name))]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "singleLabel",
                                      fn: function (props) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              style: _vm.getStylePreview(
                                                props.option
                                              ),
                                            },
                                            [_vm._v(_vm._s(props.option.name))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2870944566
                                ),
                                model: {
                                  value: _vm.selectedStyle,
                                  callback: function ($$v) {
                                    _vm.selectedStyle = $$v
                                  },
                                  expression: "selectedStyle",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "table-cell-panel__name-label mb-0",
                                  attrs: { for: "cell-name" },
                                },
                                [_vm._v("\n              Name\n            ")]
                              ),
                              _vm._v(" "),
                              _c("InfoHint", {
                                staticClass: "ml-auto mr-2",
                                attrs: {
                                  text: "Select text and click a formatting button to apply or remove formatting",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "format-hover-dropdown",
                                  on: {
                                    mouseenter: function ($event) {
                                      _vm.showFormatMenu = true
                                    },
                                    mouseleave: function ($event) {
                                      _vm.showFormatMenu = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "builder-btn builder-btn--primary",
                                      attrs: { type: "button" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Formatting\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showFormatMenu,
                                          expression: "showFormatMenu",
                                        },
                                      ],
                                      staticClass:
                                        "format-hover-dropdown__menu",
                                      on: {
                                        mousedown: function ($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "format-hover-dropdown__item",
                                          class: {
                                            active: _vm.isTagActive("b"),
                                          },
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.applyBoldTag.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Bold\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "format-hover-dropdown__item",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.insertNbsp.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Insert nbsp\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "format-hover-dropdown__item",
                                          class: {
                                            active: _vm.isTagActive("span"),
                                          },
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.insertFont.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Font\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "format-hover-dropdown__item",
                                          class: {
                                            active: _vm.isTagActive("sup"),
                                          },
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.applySupTag.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Superscript\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "format-hover-dropdown__item",
                                          class: {
                                            active: _vm.isTagActive("sub"),
                                          },
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.applySubTag.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Subscript\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-form-textarea", {
                            ref: "cellValueTa",
                            attrs: {
                              id: "cell-name",
                              value: _vm.selectedCells[0].valueHtml,
                              type: "text",
                              rows: "2",
                            },
                            on: {
                              input: (value) =>
                                (_vm.selectedCells[0].valueHtml = value),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("b-input", {
                                attrs: {
                                  id: "link",
                                  value: _vm.selectedCells[0].link,
                                  type: "text",
                                  placeholder: "Link",
                                },
                                on: {
                                  input: (value) =>
                                    (_vm.selectedCells[0].link = value),
                                },
                              }),
                              _vm._v(" "),
                              _c("InfoHint", {
                                staticClass: "ml-1",
                                attrs: {
                                  text: "Used on PDF exports to create links",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("b-input", {
                                attrs: {
                                  id: "mapping-name",
                                  value: _vm.selectedCells[0].mappingName,
                                  type: "text",
                                  placeholder: "Mapping name",
                                },
                                on: {
                                  input: _vm.onMappingNameInput,
                                  change: _vm.refreshTableData,
                                },
                              }),
                              _vm._v(" "),
                              _c("InfoHint", {
                                staticClass: "ml-1",
                                attrs: {
                                  text: "Import fills this cell on its own, by this name. Leave empty to keep the cell as it is.",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "builder-btn builder-btn--icon table-cell-panel__mapping-btn ml-1",
                                  attrs: {
                                    type: "button",
                                    disabled: !_vm.labelForSelectedCell,
                                    title: _vm.labelForSelectedCell
                                      ? `Use \u201c${_vm.labelForSelectedCell}\u201d`
                                      : "No label above or to the left",
                                  },
                                  on: { click: _vm.useLabelAsMappingName },
                                },
                                [
                                  _c("LucideIcon", {
                                    attrs: { name: "upload", size: 16 },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "table-cell-panel__controls" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "table-cell-panel__row d-flex align-items-end",
                          },
                          [
                            _c("div", [
                              _c(
                                "label",
                                {
                                  staticClass: "builder-label",
                                  attrs: { for: "font-family" },
                                },
                                [
                                  _vm._v(
                                    "\n                Font Family\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  staticClass:
                                    "custom-select custom-select-sm table-cell-panel__font-family",
                                  attrs: { id: "font-family" },
                                  domProps: { value: _vm.fontFamily },
                                  on: { input: _vm.setFontFamily },
                                },
                                _vm._l(
                                  _vm.fontsList,
                                  function (currentFont, index) {
                                    return _c(
                                      "option",
                                      {
                                        key:
                                          (currentFont.index ||
                                            currentFont.created_at) + index,
                                        style: {
                                          "font-family": currentFont.index,
                                        },
                                        domProps: {
                                          value:
                                            currentFont.index || currentFont,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              currentFont.name ||
                                                currentFont.title
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "label",
                                {
                                  staticClass: "builder-label",
                                  attrs: { for: "text-aligned" },
                                },
                                [
                                  _vm._v(
                                    "\n                Aligned\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  staticClass:
                                    "custom-select custom-select-sm table-cell-panel__align",
                                  attrs: { id: "text-aligned" },
                                  domProps: { value: _vm.align },
                                  on: { input: _vm.setFontAligned },
                                },
                                _vm._l(
                                  _vm.textAlignedList,
                                  function (item, index) {
                                    return _c(
                                      "option",
                                      {
                                        key: item.value + index,
                                        domProps: { value: item.value },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.text) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "builder-label",
                                    attrs: { for: "cell-font-size" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Font Size\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-input", {
                                  staticClass: "table-cell-panel__font-size",
                                  attrs: {
                                    id: "cell-font-size",
                                    type: "number",
                                    size: "sm",
                                  },
                                  on: {
                                    input: (value) =>
                                      _vm.handleChangeCellStyleRule(
                                        "font-size",
                                        value,
                                        "px"
                                      ),
                                  },
                                  model: {
                                    value: _vm.selectedCellTextSize,
                                    callback: function ($$v) {
                                      _vm.selectedCellTextSize = $$v
                                    },
                                    expression: "selectedCellTextSize",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "table-cell-panel__row d-flex align-items-end mt-3",
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "builder-label",
                                    attrs: { for: "cell-width" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Fixed Width\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-input", {
                                  staticClass: "table-cell-panel__number",
                                  attrs: {
                                    id: "cell-width",
                                    type: "number",
                                    size: "sm",
                                  },
                                  on: {
                                    input: (value) =>
                                      _vm.handleChangeColumnWidth(
                                        "width",
                                        value
                                      ),
                                  },
                                  model: {
                                    value: _vm.selectedCellWidth,
                                    callback: function ($$v) {
                                      _vm.selectedCellWidth = $$v
                                    },
                                    expression: "selectedCellWidth",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "builder-label",
                                    attrs: { for: "cell-min-width" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Min Width\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-input", {
                                  staticClass: "table-cell-panel__number",
                                  attrs: {
                                    id: "cell-min-width",
                                    type: "number",
                                    size: "sm",
                                  },
                                  on: {
                                    input: (value) =>
                                      _vm.handleChangeColumnWidth(
                                        "min-width",
                                        value
                                      ),
                                  },
                                  model: {
                                    value: _vm.selectedCellMinWidth,
                                    callback: function ($$v) {
                                      _vm.selectedCellMinWidth = $$v
                                    },
                                    expression: "selectedCellMinWidth",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "builder-label",
                                    attrs: { for: "cell-height" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Height\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-input", {
                                  staticClass: "table-cell-panel__number",
                                  attrs: {
                                    id: "cell-height",
                                    type: "number",
                                    size: "sm",
                                  },
                                  on: {
                                    input: (value) =>
                                      _vm.handleChangeCellHeight(value),
                                  },
                                  model: {
                                    value: _vm.selectedCellMinHeight,
                                    callback: function ($$v) {
                                      _vm.selectedCellMinHeight = $$v
                                    },
                                    expression: "selectedCellMinHeight",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "label",
                                {
                                  staticClass: "builder-label",
                                  attrs: { for: "cell-angle" },
                                },
                                [
                                  _vm._v(
                                    "\n                Angle\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex" },
                                [
                                  _c("b-input", {
                                    staticClass: "table-cell-panel__angle",
                                    attrs: {
                                      id: "cell-angle",
                                      type: "number",
                                      size: "sm",
                                    },
                                    on: {
                                      input: (value) =>
                                        _vm.handleChangeCellAngle(value),
                                    },
                                    model: {
                                      value: _vm.selectedCellAngle,
                                      callback: function ($$v) {
                                        _vm.selectedCellAngle = $$v
                                      },
                                      expression: "selectedCellAngle",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "builder-btn table-cell-panel__fit ml-1",
                                      attrs: {
                                        type: "button",
                                        title: "Fit cell to the rotated text",
                                        disabled: !_vm.hasCellAngle,
                                      },
                                      on: { click: _vm.fitCellsToAngle },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Fit\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "builder-label",
                                    attrs: { for: "cell-paddings" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Paddings\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-input", {
                                  staticClass: "table-cell-panel__number",
                                  attrs: {
                                    id: "cell-paddings",
                                    type: "text",
                                    size: "sm",
                                  },
                                  on: {
                                    input: (value) =>
                                      _vm.changeCellPaddings(value),
                                  },
                                  model: {
                                    value: _vm.selectedPaddings,
                                    callback: function ($$v) {
                                      _vm.selectedPaddings = $$v
                                    },
                                    expression: "selectedPaddings",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                staticClass: "table-cell-panel__dots",
                                attrs: { switch: "" },
                                on: { change: _vm.handleChangeCellDotLeader },
                                model: {
                                  value: _vm.selectedCellDotLeaderEnabled,
                                  callback: function ($$v) {
                                    _vm.selectedCellDotLeaderEnabled = $$v
                                  },
                                  expression: "selectedCellDotLeaderEnabled",
                                },
                              },
                              [_vm._v("\n              Dots\n            ")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "table-cell-panel__borders d-flex flex-wrap align-items-end",
                          },
                          [
                            _c("div", [
                              _c("label", { staticClass: "builder-label" }, [
                                _vm._v(
                                  "\n                Text\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "table-cell-panel__swatch" },
                                [
                                  _c("ColorPicker", {
                                    on: {
                                      input: (value) =>
                                        _vm.handleChangeCellStyleRule(
                                          "color",
                                          value,
                                          ""
                                        ),
                                    },
                                    model: {
                                      value: _vm.selectedCellTextColor,
                                      callback: function ($$v) {
                                        _vm.selectedCellTextColor = $$v
                                      },
                                      expression: "selectedCellTextColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("label", { staticClass: "builder-label" }, [
                                _vm._v(
                                  "\n                Cell\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "table-cell-panel__swatch" },
                                [
                                  _c("ColorPicker", {
                                    attrs: {
                                      "show-color-table": true,
                                      "table-color-value":
                                        _vm.selectedCellBgTableColorValue,
                                    },
                                    on: {
                                      "color-table-change":
                                        _vm.handleCellBgColorTableChange,
                                      input: (value) =>
                                        _vm.handleChangeCellStyleRule(
                                          "background-color",
                                          value,
                                          ""
                                        ),
                                    },
                                    model: {
                                      value: _vm.selectedCellBgColor,
                                      callback: function ($$v) {
                                        _vm.selectedCellBgColor = $$v
                                      },
                                      expression: "selectedCellBgColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("label", { staticClass: "builder-label" }, [
                                _vm._v(
                                  "\n                Border\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "table-cell-panel__swatch" },
                                [
                                  _c("ColorPicker", {
                                    attrs: {
                                      "show-color-table": true,
                                      "table-color-value":
                                        _vm.selectedCellTcBorderColor,
                                    },
                                    on: {
                                      "color-table-change":
                                        _vm.changeCellTcBordersColors,
                                      input: (value) =>
                                        _vm.changeCellBorders(
                                          _vm.BORDER_STYLE_RULES.BORDER_COLOR,
                                          value,
                                          ""
                                        ),
                                    },
                                    model: {
                                      value: _vm.selectedCellBorderColor,
                                      callback: function ($$v) {
                                        _vm.selectedCellBorderColor = $$v
                                      },
                                      expression: "selectedCellBorderColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "table-cell-panel__border-width" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "builder-label",
                                    attrs: { for: "cell-border-width" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Border width\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-input", {
                                  attrs: {
                                    id: "cell-border-width",
                                    type: "number",
                                    min: "1",
                                    size: "sm",
                                  },
                                  on: {
                                    input: (value) =>
                                      _vm.changeCellBorders(
                                        "border-width",
                                        value,
                                        "px"
                                      ),
                                  },
                                  model: {
                                    value: _vm.selectedCellBorderWidth,
                                    callback: function ($$v) {
                                      _vm.selectedCellBorderWidth = $$v
                                    },
                                    expression: "selectedCellBorderWidth",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "table-cell-panel__border-style" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "builder-label",
                                    attrs: { for: "border-style" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Style\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    staticClass:
                                      "custom-select custom-select-sm",
                                    attrs: { id: "border-style" },
                                    domProps: { value: _vm.borderStyle },
                                    on: { input: _vm.setBorderStyle },
                                  },
                                  _vm._l(
                                    _vm.borderStyleOptions,
                                    function (item, index) {
                                      return _c(
                                        "option",
                                        {
                                          key: item + index,
                                          domProps: { value: item },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("b-form-radio-group", {
                              staticClass: "builder-segmented",
                              attrs: {
                                options: _vm.applyToBordersOptions,
                                "button-variant": "outline-secondary",
                                size: "sm",
                                buttons: "",
                              },
                              on: { change: _vm.changeBorderOption },
                              model: {
                                value: _vm.applyToBorders,
                                callback: function ($$v) {
                                  _vm.applyToBorders = $$v
                                },
                                expression: "applyToBorders",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "table-cell-panel__apply d-flex flex-wrap align-items-center",
                          },
                          [
                            _c("label", { staticClass: "builder-label mb-0" }, [
                              _vm._v("\n              Apply to\n            "),
                            ]),
                            _vm._v(" "),
                            _c("b-form-radio-group", {
                              staticClass: "builder-segmented",
                              attrs: {
                                options: _vm.applyToOptions,
                                "button-variant": "outline-secondary",
                                size: "sm",
                                buttons: "",
                              },
                              model: {
                                value: _vm.applyToCells,
                                callback: function ($$v) {
                                  _vm.applyToCells = $$v
                                },
                                expression: "applyToCells",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "builder-btn builder-btn--icon",
                                attrs: {
                                  type: "button",
                                  title: "Put an image into the selected cells",
                                },
                                on: { click: _vm.showFileUploadModal },
                              },
                              [
                                _c("LucideIcon", {
                                  attrs: { name: "image", size: 16 },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "builder-btn builder-btn--icon",
                                attrs: {
                                  type: "button",
                                  title: _vm.columnStyles.length
                                    ? "Click a cell to paste the copied styles onto its column"
                                    : "Copy the styles of this column",
                                },
                                on: { click: _vm.copyColumnStyle },
                              },
                              [
                                _c("LucideIcon", {
                                  attrs: {
                                    name: _vm.columnStyles.length
                                      ? "clipboard-check"
                                      : "clipboard",
                                    size: 16,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "table-cell-panel__span" }, [
                        _c("div", { staticClass: "d-flex" }, [
                          _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "builder-label",
                                  attrs: { for: "cell-colspan" },
                                },
                                [
                                  _vm._v(
                                    "\n                Colspan\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-input", {
                                staticClass: "table-cell-panel__span-input",
                                attrs: {
                                  id: "cell-colspan",
                                  value: _vm.selectedCells[0].colspan,
                                  type: "number",
                                  disabled: _vm.selectedCells.length > 1,
                                  size: "sm",
                                },
                                on: {
                                  input: (value) =>
                                    (_vm.selectedCells[0].colspan = value),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "builder-label",
                                  attrs: { for: "cell-rowspan" },
                                },
                                [
                                  _vm._v(
                                    "\n                Rowspan\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-input", {
                                staticClass: "table-cell-panel__span-input",
                                attrs: {
                                  id: "cell-rowspan",
                                  value: _vm.selectedCells[0].rowspan,
                                  type: "number",
                                  disabled:
                                    _vm.selectedCells.length > 1 ||
                                    _vm.isCellHead,
                                  size: "sm",
                                },
                                on: {
                                  input: (value) =>
                                    (_vm.selectedCells[0].rowspan = value),
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-flex mt-2" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "builder-btn flex-fill justify-content-center mr-2",
                              attrs: { type: "button" },
                              on: { click: _vm.onCancel },
                            },
                            [_vm._v("\n              Cancel\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "builder-btn builder-btn--primary flex-fill justify-content-center",
                              attrs: { type: "button" },
                              on: { click: _vm.onApply },
                            },
                            [_vm._v("\n              Apply\n            ")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "table-cell-panel__hint",
                            attrs: { title: _vm.columnWidthsHint.title },
                          },
                          [
                            _vm._v(
                              "\n            Sum column widths: " +
                                _vm._s(_vm.setColumnWidthsSum) +
                                "\n            "
                            ),
                            _vm.renderedColumnsWidth &&
                            _vm.renderedColumnsWidth !== _vm.setColumnWidthsSum
                              ? _c("span", [
                                  _vm._v(
                                    "\n              → renders " +
                                      _vm._s(_vm.renderedColumnsWidth) +
                                      "\n            "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.columnsToTableGap
                              ? _c("span", [
                                  _vm._v(
                                    "\n              + " +
                                      _vm._s(_vm.columnsToTableGap) +
                                      " " +
                                      _vm._s(_vm.columnWidthsHint.gapLabel) +
                                      "\n            "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.tableOuterWidth
                              ? _c("span", [
                                  _vm._v(
                                    "\n              = " +
                                      _vm._s(_vm.tableOuterWidth) +
                                      " (W)\n            "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.columnOverflows.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "table-cell-panel__hint table-cell-panel__hint--danger",
                              },
                              [
                                _vm._v(
                                  "\n            Some columns need more room than they were given:\n            "
                                ),
                                _vm._l(
                                  _vm.columnOverflows,
                                  function (overflow, index) {
                                    return _c(
                                      "span",
                                      {
                                        key:
                                          overflow.requested +
                                          "_" +
                                          overflow.used,
                                        staticClass: "font-bold",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(index ? ", " : "") +
                                            _vm._s(overflow.requested) +
                                            " → " +
                                            _vm._s(overflow.used)
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.columnsSurplus > 1
                          ? _c(
                              "div",
                              { staticClass: "table-cell-panel__hint" },
                              [
                                _vm._v("\n            The table is "),
                                _c("span", { staticClass: "font-bold" }, [
                                  _vm._v(_vm._s(_vm.columnsSurplus) + "px"),
                                ]),
                                _vm._v(
                                  " wider than its\n            columns need, so the extra is shared out across all of them. Set W to\n            "
                                ),
                                _c("span", { staticClass: "font-bold" }, [
                                  _vm._v(_vm._s(_vm.naturalTableWidth)),
                                ]),
                                _vm._v(" to stop it.\n          "),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.columnsSqueeze > 1
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "table-cell-panel__hint table-cell-panel__hint--danger",
                              },
                              [
                                _vm._v("\n            The table is "),
                                _c("span", { staticClass: "font-bold" }, [
                                  _vm._v(_vm._s(_vm.columnsSqueeze) + "px"),
                                ]),
                                _vm._v(
                                  " narrower than\n            its columns need, so every column is squeezed below the width it was given. Set W\n            to "
                                ),
                                _c("span", { staticClass: "font-bold" }, [
                                  _vm._v(_vm._s(_vm.naturalTableWidth)),
                                ]),
                                _vm._v(
                                  " to give them the full\n            amount.\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "builder-label table-preview-label" },
                  [_vm._v("\n        Preview\n      ")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.table && _vm.table.rows.length
            ? _c(
                "div",
                {
                  ref: "tableContainer",
                  staticClass: "table-builder-container",
                  class: {
                    "table-builder-container--fullscreen": _vm.isFullscreen,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "table-zoom-stage",
                      style: _vm.zoomStageStyle,
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "table-zoom-source",
                          style: _vm.zoomSourceStyle,
                        },
                        [
                          _c(
                            "table",
                            {
                              ref: "table",
                              staticClass: "no-select",
                              style: _vm.getStyleOfTable,
                            },
                            [
                              _c(
                                "tbody",
                                _vm._l(_vm.visualRows, function (visualRow) {
                                  return _c(
                                    "tr",
                                    {
                                      key: visualRow.key,
                                      style: visualRow.style,
                                    },
                                    _vm._l(
                                      visualRow.cells,
                                      function (cell, index) {
                                        return _c(
                                          "td",
                                          {
                                            key: cell.id + "_" + index,
                                            class: {
                                              "selected-cell":
                                                _vm.selectedCells.some(
                                                  (item) => item.id === cell.id
                                                ),
                                              "editing-cell":
                                                _vm.editingCellId === cell.id,
                                            },
                                            style: cell.stringStyles,
                                            attrs: {
                                              colspan: cell.colspan,
                                              rowspan: cell.rowspan,
                                            },
                                            on: {
                                              mousedown: (event) =>
                                                _vm.onCellMouseDown(
                                                  event,
                                                  cell
                                                ),
                                            },
                                          },
                                          [
                                            cell.src
                                              ? _c("img", {
                                                  staticStyle: {
                                                    width: "100%",
                                                    height: "100%",
                                                  },
                                                  attrs: {
                                                    src: cell.src,
                                                    alt: "img",
                                                  },
                                                })
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cell-content-shell",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "cell-editor",
                                                          class: {
                                                            "cell-editor-inactive":
                                                              _vm.editingCellId !==
                                                              cell.id,
                                                          },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              cell.valueHtml ||
                                                                ""
                                                            ),
                                                          },
                                                          on: {
                                                            input: (event) =>
                                                              _vm.onCellTextInput(
                                                                event,
                                                                cell
                                                              ),
                                                            blur: (event) =>
                                                              _vm.onCellTextBlur(
                                                                event,
                                                                cell
                                                              ),
                                                            keydown: (event) =>
                                                              _vm.onCellKeyDown(
                                                                event,
                                                                cell
                                                              ),
                                                            focus: (event) =>
                                                              _vm.onCellFocus(
                                                                event,
                                                                cell
                                                              ),
                                                          },
                                                        },
                                                        "div",
                                                        _vm.editingCellId ===
                                                          cell.id
                                                          ? {
                                                              contenteditable:
                                                                "true",
                                                            }
                                                          : {},
                                                        false
                                                      )
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.editingCellId !==
                                                    cell.id
                                                      ? _c("div", {
                                                          staticClass:
                                                            "cell-display",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.getRenderedCellHtml(
                                                                cell
                                                              )
                                                            ),
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _c(
                "div",
                { staticClass: "d-flex justify-content-center" },
                [
                  _c(
                    "b-dropdown",
                    {
                      attrs: {
                        text: "Create Table",
                        "menu-class": "table-create-menu",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "p-2" },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "w-50 pr-1" },
                                [
                                  _c("label", [_vm._v("Columns")]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "number",
                                      min: "1",
                                      step: "1",
                                      size: "sm",
                                      state: _vm.isValidGridSize(
                                        _vm.createTable.columns
                                      )
                                        ? null
                                        : false,
                                    },
                                    model: {
                                      value: _vm.createTable.columns,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.createTable,
                                          "columns",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "createTable.columns",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { staticClass: "w-50 pl-1" },
                                [
                                  _c("label", [_vm._v("Rows")]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "number",
                                      min: "1",
                                      step: "1",
                                      size: "sm",
                                      state: _vm.isValidGridSize(
                                        _vm.createTable.rows
                                      )
                                        ? null
                                        : false,
                                    },
                                    model: {
                                      value: _vm.createTable.rows,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.createTable,
                                          "rows",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "createTable.rows",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "w-100",
                              attrs: {
                                variant: "primary",
                                size: "sm",
                                disabled: !_vm.canCreateTable,
                              },
                              on: { click: _vm.onCreateTable },
                            },
                            [_vm._v("\n            Create\n          ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
        ]
      ),
      _vm._v(" "),
      _c("TableFileUploadModal", {
        ref: "tableFileUploadModal",
        attrs: { src: _vm.selectedCellUrl },
        on: { save: _vm.handleAddImage },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }